// extracted by mini-css-extract-plugin
export default {"modal":"_1K3y0","linksList":"_2hqsZ","link":"_1zsnn"};